import React from "react";

export default function Legal() {
  return (
    <section className="pc:gap-10 col-span-8 flex h-fit w-full flex-col gap-5 wrap-break-word">
      <h2 className="text-title pc:flex hidden">Legal</h2>

      <section className="flex flex-col gap-5">
        <div className="flex flex-col gap-2.5">
          <h3>2022年9月1日改訂</h3>
          <p className="font-fuzzy-light">
            本サイトをご利用の際は本規約に同意いただく必要がございます。
            <br />
            利用者の皆様が本サイト等を利用した場合には、本利用規約に同意したものとみなされます。本利用規約に同意されない方は、本サイト等のご利用をお控えください。
            <br />
            <br />
            JKND JAPAN 株式会社（以下、「当社」といいます）は、thisisneverthat.jp
            <br />
            （以下、「本サイト」といいます）の利用並びに本サイトを通じて提供とれするthisisnevethat®オンラインショップ（以下、「本サービス」といい、本サイトと総称して「本サービス等」といいます）の利用に関する規約を以下のとおり定めます。本サービス等を利用するためには、この利用規約（以下、「本利用規約」といいます）に同意いただく必要があります。
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          <ol className="font-fuzzy-light list-disc pl-5">
            <li>第１条 本利用規約の範囲及び変更</li>
            <li>第２条 利用者</li>
            <li>第４条 禁止事項</li>
            <li>第５条 著作権</li>
            <li>第６条 免責</li>
            <li>第７条 損害賠償等</li>
            <li>第８条 商品の購入</li>
            <li>第９条 購入数の制限</li>
            <li>第１０条 商品等の発送</li>
            <li>第１１条 送料及び手数料</li>
            <li>第１２条 商品の決済方法</li>
            <li>第１３条 商品の返品等</li>
            <li>第１４条 商品に関する免責</li>
            <li>第１５条 個人情報の取り扱い</li>
            <li>第１６条 秘密保持</li>
            <li>第１７条 譲渡禁止</li>
            <li>第１８条 分離可能性</li>
            <li>第１９条 通知</li>
            <li>第２０条 準拠法及び管轄裁判所</li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１条 本利用規約の範囲及び変更</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>本利用規約は、本サービス等の利用に関し、当社及び利用者に適用されるものとします。</li>
            <li>
              当社は、本利用規約の変更又は更新が必要であると判断した場合、利用者の承諾を得ること無く、本サイト内等で利用者に対して通知を行うことにより、本利用規約の全部若しくは一部を変更又は更新出来るものとします。
            </li>
            <li>
              本利用規約の変更又は更新の効力発生時期については、前項の通知に記載されます。また、利用者が本利用規約の変更又は更新後も本サービス等を利用した場合は、利用者には更新後の本利用規約が適用されます。本サービス等のご利用の際には、随時、本ページに記載する最新の本利用規約をご確認ください。
            </li>
            <li>本利用規約が変更された場合、変更後の本利用規約のみが適用されるものとします。</li>
            <li>
              本利用規約の内容と当社の定めた他の説明・ルール等（以下「特約」といいます）が異なる場合は、特約の内容が優先的に適用されるものとします。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第２条 利用者</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              本利用規約において、「利用者」とは本利用規約に同意した上で、本サービス等を利用する全ての方をいいます。また、利用者は本サービス等の利用を開始した時点で、本利用規約の内容に同意したものとみなされます。
            </li>
            <li>
              利用者が未成年者の場合は、法定代理人の事前の同意を得なければ、本サービスを利用出来ないものとし、本サービスを利用した時点で、本サービスの利用（本サイトにおける商品の購入をいいます）に関する法定代理人の同意があったものとみなします。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第３条 本サービス等の利用</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              利用者は本サービス等を利用するにあたって、本利用規約の定めに従い、かつその他当社が定める方法によってのみ本サービス等を利用するものとします。
            </li>
            <li>
              利用者は本サービス等を利用して営利を目的とした活動を行う場合、あるいは本サービス等を通じて入手した情報（本サイト上のコンテンツを含みます）を複製、改変、転用、販売、出版その他私的利用の範囲を超えて使用する場合は、全て当社の事前の書面による承諾を得るものとします。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第４条 禁止事項</h3>
          <span>
            利用者は、本サービス等を利用するにあたり以下の各号のいずれかに該当する行為又は該当すると当社が判断する行為を行ってはならないものとします。
          </span>
          <ol className="font-fuzzy-light list-decimal">
            <li>本サービス等を利用する際、虚偽の情報を提供し又は第三者になりすます行為。</li>
            <li>本サービス等の運営を妨げ、その他当社による本サービス等の提供に支障をきたすおそれのある行為。</li>
            <li>
              当社、他の利用者、又は第三者の権利（商標権、著作権、意匠権、特許権などの知的財産権、肖像権、プライバシー権、パブリシティ権等を含みますがこれらに限られません）を侵害する行為、又は侵害するおそれのある行為。
            </li>
            <li>当社、他の利用者、又は第三者に迷惑、不利益若しくは損害を与える行為、又はそれらのおそれがある行為。</li>
            <li>クレジットカードを不正使用して本サービスを利用する行為。</li>
            <li>詐欺等の犯罪行為又は犯罪に関連する行為。</li>
            <li>法令、本利用規約又は公序良俗に違反する行為。</li>
            <li>
              当社の事業の運営を妨げる行為、当社の信用若しくは利益を損なう行為、若しくは当社に損害を与える行為、又はそのおそれのある行為。
            </li>
            <li>当社、他の利用者又は第三者の情報を改ざん、消去等する行為。</li>
            <li>コンピューターウィルスなどの有害なプログラム等を送信若しくは提供等する行為、又は推奨する行為。</li>
            <li>転売等営利を目的として商品を購入する行為。</li>
            <li>通常とは異なる方法により注文をする行為。</li>
            <li>その他当社が不適切と判断する行為。</li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第５条 著作権</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              本サイトに掲載されている全てのコンテンツ（画像、テキスト、ロゴ、映像、プログラムを含みますがこれらに限られません。以下、総称して「コンテンツ」といいます）の著作権、商標権及びその他の知的財産権は、全て当社又は当社が使用許諾を得た第三者に帰属するものです。本利用規約に基づく本サービス等の利用は、利用者に対し当社又は当社が使用許諾を得た第三者に帰属する知的財産権の移転や使用許諾を意味するものではありません。
            </li>
            <li>
              利用者は、目的の如何を問わず、当社の許可無く、本サイト又は本サイトに掲載されたコンテンツの複製、改変、転用、配布、提示、作成、リンクの提供、二次利用等を行わないものとします。
            </li>
            <li>
              利用者が、前項に定める行為その他国内又は国外の著作権法その他の法令により禁止される行為を行った場合、当社は利用者に対して法的措置をとる場合があります。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第６条 免責</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              当社は、本利用規約に別途定めるものを除き、本サービス等（本サービスを通じて当社が提供する情報等を含みます）の完全性、正確性、適用性、有用性及び合理性等について、いかなる保証も行いません。
            </li>
            <li>
              当社は本サービス等の停止、中止、変更又は終了により発生した利用者又は第三者の損害に対し、一切責任を負わないものとします。
            </li>
            <li>
              当社は、本サービス等の利用に関連し、又は本利用規約に従い当社が行った行為に起因して、利用者が直接又は間接的に被り得る損害について、その内容、態様のいかんに関わらず一切責任を負わないものとします。但し、当社に故意又は重過失がある場合を除きます。
            </li>
            <li>
              当社は、本サービス等の利用に関連し、利用者が入力した情報が誤っていたこと又は最新の情報でなかったこと等に起因して、利用者が直接又は間接的に被り得る損害について、その内容、態様のいかんに関わらず一切責任を負わないものとします。
            </li>
            <li>
              利用者は、本サービスの利用に関連し、利用者が受け取った「ご注文内容の確認」メール、発送完了メール、商品到着時に同梱されている納品書等（以下、総称して「注文内容メール等」といいます）について、自己の責任において管理するものとします。当社は、注文内容メール等にかかる内容を第三者が知り得たこと等により、利用者が直接又は間接的に被り得る損害について、その内容、態様のいかんに関わらず一切責任を負わないものとします。
            </li>
            <li>
              当社は、以下の各号のいずれかに該当する場合には、本サービスを停止、中止変更、又は終了することができるものとします。当社は、かかる停止、中止、変更又は終了により利用者が直接又は間接的に被り得る損害について、その内容、態様のいかんに関わらず一切責任を負わないものとします。
              <ol>
                <li>火災、地震、洪水、落雷、大雪等天変地異が生じた場合。</li>
                <li>戦争、内乱、テロ、暴動、騒乱等の社会不安が生じた場合。</li>
                <li>当社が契約している運送会社又はプロバイダから適切なサービスを受けられなかった場合。</li>
                <li>当社が技術的に対応不可能な事由が生じた場合。</li>
                <li>その他当社が本サービスを停止、中止、変更又は終了する必要があると判断した場合。</li>
              </ol>
            </li>
            <li>
              何らかの理由により当社が責任を負う場合であっても、特別な事情から利用者に生じた損害については、予見性の有無を問わず、当社は責任を負わないものとします。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第７条 損害賠償等</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              利用者は、本利用規約に違反し、又は、本サービス等の利用に関連して当社に損害を与えた場合、当社に対しその損害を賠償するものとします。
            </li>
            <li>
              利用者は、本利用規約の規定の違反その他本サービスの利用により、利用者と第三者との間で問題が生じた場合、自己の責任と費用においてかかる問題を解決するとともに、当社に何らの損害、損失及び不利益等を与えないようにするものとします。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第８条 商品の購入</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>利用者は本サービスを利用して当社から商品又はサービス（以下、総称して「商品等」といいます）を購入することが出来ます。</li>
            <li>利用者は、当社の定める方法により商品等の購入を申し込むものとします。</li>
            <li>
              前項の申込に対して、注文の受領確認と注文内容を記載した「ご注文内容の確認」メールが当社から送信された時点で、利用者と当社の間に当該申込に係る商品等について売買契約（以下、「本売買契約」といいます）が成立するものとします。
            </li>
            <li>
              前項の規定にかかわらず、本サービスの利用に関して、以下の各号のいずれかに該当する場合又は該当すると当社が判断した場合、当社は本売買契約の取消、解除、その他適切な措置（以下、総称して「取消等」といいます）をとることが出来るものとします。当社は、本売買契約の取消等に伴い生じた損害、損失、不利益等については、いかなる保証・負担も行いません。
              <ol>
                <li>利用者が過去に本利用規約等に違反していることが判明した場合。</li>
                <li>利用者の情報に虚偽の表示、誤記、又は不備等があることが判明した場合。</li>
                <li>利用者に生じる債務の履行が不確実である場合。</li>
                <li>
                  利用者が不正な売買（転売等の営利目的での購入、第三者になりすました購入を含みますが、これらに限られません。以下本号において同様です。）を行い若しくは行うおそれがある場合又は過去に不正な売買を行った場合。
                </li>
                <li>売り切れその他の理由により商品の調達が不可能な場合。</li>
                <li>商品の欠陥等が見つかり代替品が用意出来ない場合。</li>
                <li>当社が別途定めた購入制限数を超えて利用者が注文をした場合。</li>
                <li>その他取消等を行う必要がある場合。</li>
              </ol>
            </li>
            <li>
              当社のシステム上、カート内に商品等を入れた状態は商品等を確保した状態とは異なります。利用者が決済を完了し、当社から「ご注文内容の確認」メールが送信された時点で本売買契約が成立します。そのため、カート内に商品がある状態でも、時間差で完売した場合にはそのまま決済を進めることが出来ない場合があります。その場合はカート内の商品等を削除してください。これらの事由により生じた損害、損失、不利益等については、当社はいかなる保証又は負担も行いません。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第９条 購入数の制限</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              当社は、商品等によって、利用者に対して、購入数を制限する場合があります。これにより、より多くの利用者にご購入の機会を提供させていただけると考えております。
            </li>
            <li>
              利用者が前項の制限を越えて商品等の注文をした場合、当社は注文の取消等をする場合があります。当社は、注文の取消等によって生じた損害、損失、不利益等についていかなる保証・負担も行いません。
            </li>
            <li>
              購入数の制限、注文の取消等を行うかどうかの判断基準は販売する商品等によって異なり、全ての商品等に対して同様に適用されるものでは無いものとします。
            </li>
            <li>当社は、購入数の制限、注文の取消等の判断基準の詳細等に関するお問い合わせへのご回答やご案内等は致しかねます。</li>
            <li>
              第２項の規定により取消となる注文は全て２回目以降のものとなり、確定される注文は、一番若い受注番号のものとなります。利用者が２回目以降に行った注文内容（色、サイズなど）の購入を希望する場合でも、当社は当該希望に応じられません。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１０条 商品等の発送</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>当社は、通常、注文確定日より平日５営業日以内に商品等をヤマト運輸にて発送致します(年末年始ならびに大型連休を除きます)。</li>
            <li>
              利用者に対する商品等の引き渡し日は、当社が任意に定めることができるものとし、利用者は、原則配送日時指定は出来ないものとします。但し利用者の要望があった場合、本売買契約から1週間以内の日程の指定は受け入れるものとします。
            </li>
            <li>
              注文時に利用者が入力する届け先住所は、利用者が居住する住所のみとし、当社は、佐川急便等配達業者が、利用者の居住が確認出来ない住所への発送は行わないものとします。
            </li>
            <li>
              利用者が、利用者の居住が確認出来ない住所を届け先住所として入力した場合のほか、長期不在や受け取り拒否その他利用者の責に帰すべき理由により商品の配送が完了しない場合には、当社は、利用者に対し、利用者が居住する住所の確認等必要な連絡をさせていただきます。利用者の責に帰すべき理由により商品の配送が完了しない場合は注文の取消をさせていただきます。
            </li>
            <li>利用者は、当社所定の方法及び時期に従って届け出ない限り、商品等の配送先の変更は出来ないものとします。</li>
            <li>当社は、利用者が別々に行った注文の同梱発送はお受け致しかねます。</li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１１条 送料及び手数料</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>商品等の配送に係る送料は、当社が指定した送料を利用者が負担するものとします。</li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１２条 商品の決済方法</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              利用者が、本サービスで商品等を購入した際に支払う金額は消費税を含む商品購入代金及びこれに係る配送料、その他手数料の合計となります。
            </li>
            <li>
              本サービスによって購入された商品等のお支払いに関しては、購入者である利用者本人名義のクレジットカード（VISA、MASTER、JCB、AMEX）によるお支払い、各種決済サービス(Apple
              Pay, Google Pay, Amazon Pay,
              PyaPal)のみとします。クレジットカードのお支払い方法はご一括払いのみとなります。デビットカード等口座直結型のカードをご利用の場合、カード会社への利用確認時に与信（オーソリ）が確保された時点で、利用者の口座へ購入金額分が利用枠として反映される場合がございます。その際カード会社から利用者へ送られる利用案内や利用履歴等で本サービスでの利用が確認可能な状態でも、本サービスでの注文を確定するものではございません。当社からの「ご注文内容の確認」メールの送信をもちまして注文確定となります。注文が確定していないにも関わらず確保された利用枠に関しましては、当社にて注文の取消等をさせていただきます。取消等後、利用者の口座への反映にはお時間をいただく場合がございます。
            </li>
            <li>当社は、ご注文確定後の決済方法のご変更はお受け致しかねます。</li>
            <li>
              当社は、一部の商品等について、決済方法を限定させていただく場合があります。利用者が複数の商品を購入した際、当該商品中に決済方法が限定された商品が含まれる場合は、決済方法は限定された方法のみとなります。
            </li>
            <li>
              利用者がクレジットカードでの支払いを選択した場合は、その支払い方法等については、本利用規約のほか、利用者がクレジットカード会社との間で別途契約する条件に従うものとします。なお、クレジットカードでの支払い方法等をめぐり、利用者と当該クレジットカード会社等の第三者との間で紛争が発生した場合は、利用者は自己の責任と費用においてかかる問題を解決するとともに、当社に何らの損害、損失又は不利益等を与えないようにするものとします。
            </li>
            <li>
              クレジットカードでのお支払いの際に、入力情報に不備があった場合、当社は、入力情報の確認のため商品の発送を保留する場合があります。その場合、当社は、入力情報の正確性について確認が取れ次第、商品を発送致します。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１３条 商品の返品等</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              注文確定後の利用者の都合（サイズが合わない、注文を間違えた、イメージと異なる、長期不在又は受け取り拒否その他利用者の事情等。）による商品等の返品、返金もしくは交換、又は、注文のキャンセル、注文内容の変更（色、サイズの交換等を含みます）、商品の一方的な返送は一切受け付けておりません。
            </li>
            <li>
              クレジットカードでのお支払いの際に、入力情報に不備があった場合、当社は、入力情報の確認のため商品の発送を保留する場合があります。その場合、当社は、入力情報の正確性について確認が取れ次第、商品を発送致します。
            </li>
            <li>
              当社において商品等の在庫が無く、新しい商品等との交換が出来ない場合に限り、当社は以下の方法により利用者に対し返品、返金を行うものとします。
              <ol>
                <li>利用者がクレジットカードにより商品を購入された場合</li>
                <li>当社によりクレジットカードの請求を取消すものといたします。</li>
                <li>
                  クレジットカード会社の締日等の関係上、上記a)に基づく請求取消し以前に返品を行った商品等の代金が引き落とされた場合は、当社は翌月以降クレジットカード会社を通じて利用者に対する返金、又はご利用分からの差し引き等の処理を行います。
                </li>
                <li>
                  上記a)b)にかかわらず、当社によるクレジットカードの請求取消しが実行できないやむを得ない事情があると当社が判断した場合に限り、商品等を注文した購入者である利用者本人の名義と確認される口座へのみ返金を行います。
                </li>
                <li>
                  利用者が代引決済で商品等を購入された場合
                  <br />
                  商品等を注文した購入者である利用者本人の名義と確認される口座へのみ返金を行います。
                </li>
                <li>当社において商品等の在庫がある場合には、当社は利用者に対し商品等の交換をいたします。</li>
              </ol>
            </li>
            <li>
              前項に定める返品、返金又は交換は、以下の各号の全てに該当する場合にのみ行うものとします。
              <ol>
                <li>返品、返金又は交換される商品等が未使用であること（商品タグが付いていない場合は、未使用と認められません）。</li>
                <li>返品、返金又は交換される商品等が未使用であること（商品タグが付いていない場合は、未使用と認められません）。</li>
                <li>その他別途当社が指定する事項を満たしていること。</li>
              </ol>
            </li>
            <li>
              利用者は、商品等を受け取った際には必ず商品等の状態を確認するものとします。利用者は、破損、瑕疵、又は当社の故意若しくは過失による破損、瑕疵、誤送により、商品等の返品又は交換を希望する場合、商品等到着後７日以内に、受注番号・氏名・住所・該当箇所の画像を記載したEメールにて、利用者本人から当社に対し連絡するものとします。
            </li>
            <li>
              当社は、前項のEメールを受領した後、返送方法等を利用者に連絡いたします。当社から利用者に対して返送依頼を行った後、当該商品等が当社の当該依頼の送信日から７日以内に当社に到着した場合に限り、本条の基準にしたがい、当社は商品等を新しい商品等と交換致します。その際、利用者による他の商品等、色、サイズへの変更は出来ないものとします。
            </li>
            <li>
              当社は、利用者から商品等到着後７日以内に連絡を受けた場合であっても、以下の各号のいずれかに該当する商品の返品、返金又は交換はお受け致しかねます。
              <ol>
                <li>当社にて製品基準内と判断された商品等。</li>
                <li>利用者が使用した商品等。</li>
                <li>利用者が使用した商品等。</li>
                <li>利用者が加工又はカスタマイズ等を行った商品等、又は修理若しくはクリーニングされた商品等。</li>
                <li>パッケージ等が汚損・破損・紛失・破棄された商品等。</li>
              </ol>
            </li>
            <li>パッケージ等が汚損・破損・紛失・破棄された商品等。</li>
            <li>
              本サイトに掲載されている商品画像はサンプルとなるため、実際の製品と仕様が異なる場合がございます。また、パソコンや携帯端末での閲覧という特性上、利用者の本サイトの閲覧環境によっては商品等の画像が実際の色目と多少異なる場合があります。当社は、画像の色目と実際の色目の軽微な違いについては、商品等の瑕疵として扱いません。
            </li>
            <li>
              佐川急便にて配送後、荷物の保管期限は初回配達日より７日間となります。当社は、長期不在や受取拒否等、利用者の都合により利用者が受け取ることができず、当社に返送された商品等について、原則再配送はお受け致しかねます。また、利用者による一方的な商品等の返送も固くお断りいたします。当社は、以上の行為を行った利用者による、以降の注文に関しましてお断りさせていただく場合がございます。
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１４条 商品に関する免責</h3>
          <p className="font-fuzzy-light">
            当社は、本サービスを通じて売買される商品等につき、その品質、性能、他の商品との適合性その他の欠陥、及びこれらが原因となり生じた損害、損失、不利益等については、前条に定める場合を除き、いかなる保証・負担も行いません。但し、当社に故意又は重過失がある場合を除きます。
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１５条 個人情報の取り扱い</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              当社は、本サービスの提供にあたり利用者に関する以下の情報（以下、総称して「個人情報」といいます）を取得します。
              <ol>
                <li>
                  氏名、郵便番号、住所、電話番号、メールアドレスその他当社が定める入力フォームに利用者が入力する情報。ただし、当社は、決済手続きを第三者に委託しており、入力フォームにご入力いただいたお客様のクレジットカード情報は、当社では一切取扱いません。クレジットカード払いへの変更を希望される場合その他いかなる場合であっても、当社に対し、クレジットカード情報をお送りにならないようにお願いいたします。なお、本規約第１２条第３項のとおり、注文確定後の支払方法変更は原則お受けできません。
                </li>
                <li>
                  利用者がインターネットにアクセスするときに使われるIPアドレス、ブラウザの種類、バージョンオペレーティングシステム情報、その他クッキーを使用して記録したアクセス情報等を含む、利用者による本サイトへのアクセスにより自動的に記録される情報。
                </li>
              </ol>
            </li>
            <li>
              当社は、前項に基づき取得した個人情報を以下の目的で利用します。
              <ol>
                <li>本サイトの運営上必要な事項の通知。（Eメールによるものを含むものとします。</li>
                <li>メールマガジンの送信。</li>
                <li>商品の梱包・発送。</li>
                <li>金計算、料金請求。</li>
                <li>各種問い合わせ、依頼等への対応。</li>
                <li>本サービスの提供に必要なマーケティングデータの調査・分析、当社のサービス開発。</li>
              </ol>
            </li>
            <li>
              当社は、利用者から取得した個人情報について、本利用規約及び個人情報保護法に従い取り扱うとともに、情報セキュリティ対策をはじめとする個人情報保護方策を実施し、個人情報の漏洩、減失又は毀損等の是正及び予防に努めます。
            </li>
            <li>当社は、本利用規約及び個人情報保護法に規定する場合を除き、利用者の個人情報を第三者に開示致しません。</li>
            <li>
              個人情報に関するお問い合わせ先
              <br />
              利用者が、当社に対して、個人情報に関する問い合わせを行う場合、以下の宛先にメールで連絡するものとします。
              <br />
              JKND JAPAN 株式会社
              <br />
              Eメール： jp@thisisneverthat.com
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１６条 秘密保持</h3>
          <p className="font-fuzzy-light">
            利用者は、本サービスの提供又は本売買契約に関連して利用者が秘密に取り扱うことを求めて開示した非公知の情報について秘密として取り扱い、当社の事前の書面による同意がない限り、第三者に対して漏洩又は開示等を行わないものとします。
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１７条 譲渡禁止</h3>
          <p className="font-fuzzy-light">
            利用者は、当社の事前の書面による同意がない限り、本売買契約又は本利用規約上の権利、義務又は地位について、第三者に対し譲渡又は担保設定等の処分をすることが出来ないものとします。
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１８条 分離可能性</h3>
          <p className="font-fuzzy-light">
            本利用規約の一部が法令により無効又は執行不能と判断された場合であっても、本利用規約の残部は引き続き完全な効力を有するものとします。
          </p>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第１９条 通知</h3>
          <ol className="font-fuzzy-light list-decimal">
            <li>
              本サービスの利用に関する当社と利用者との連絡方法は、原則としてEメール（ jp@thisisneverthat.com
              ）によってのみ行うものとします。
            </li>
            <li>
              携帯電話メールアドレスでは、当社からのご注文確認メール等が正しく表示されない可能性があるため、利用者は携帯電話メールアドレス以外のアドレスを使用するものとします。利用者が携帯電話メールアドレスを使用したことに起因
            </li>
          </ol>
        </div>

        <div className="flex flex-col gap-2.5">
          <h3>第２０条 準拠法及び管轄裁判所</h3>
          <p className="font-fuzzy-light">
            本利用規約及び本売買契約の準拠法は日本法とし、本サービス又は本利用規約に関する一切の紛争については、東京地方裁判所又は東京簡易裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
        </div>
      </section>
    </section>
  );
}
